import {Component} from '@angular/core';
import {EfaStorefrontComponent} from "@shared/components/efa-storefront/efa-storefront.component";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [EfaStorefrontComponent]
})
export class AppComponent {
  title = 'efastore';
}
